import { dispatchAction } from '@ardoq/rxbeach';
import { hideViewSidePanel } from 'views/mainApp/viewSidePanel/actions';
import { toggleSidebarPanel } from '../sidebarPanel/actions';
import { SidebarPanelContentIds } from '../sidebarPanel/types';

type ContextToolBarCommands = {
  hidePane: VoidFunction;
  toggleContextPanel: VoidFunction;
  toggleViewpointsPanel: VoidFunction;
  toggleCreateReferencesPanel: VoidFunction;
  toggleDetailsPanel: VoidFunction;
  toggleDatasetsPanel: VoidFunction;
};

const hidePane = () => {
  dispatchAction(hideViewSidePanel());
};

const toggleContextPanel = () => {
  dispatchAction(toggleSidebarPanel(SidebarPanelContentIds.CONTEXT_SWITCHER));
};
const toggleViewpointsPanel = () => {
  dispatchAction(toggleSidebarPanel(SidebarPanelContentIds.VIEWPOINT_SWITCHER));
};
const toggleCreateReferencesPanel = () => {
  dispatchAction(toggleSidebarPanel(SidebarPanelContentIds.CREATE_REFERENCES));
};
const toggleDetailsPanel = () => {
  dispatchAction(toggleSidebarPanel(SidebarPanelContentIds.DETAILS));
};
const toggleDatasetsPanel = () => {
  dispatchAction(toggleSidebarPanel(SidebarPanelContentIds.DATASETS));
};

export const contextToolBarCommands: ContextToolBarCommands = {
  hidePane,
  toggleContextPanel,
  toggleViewpointsPanel,
  toggleCreateReferencesPanel,
  toggleDetailsPanel,
  toggleDatasetsPanel,
};
